// eslint-disable-next-line
type FilterQuery = { [key: string]: any };

const canonical = (query: FilterQuery): string => {
  const params = new URLSearchParams();
  Object.keys(query || {}).forEach((key) => {
    const value = query[key];
    (Array.isArray(value) ? value : [value])
      .filter((entry) => entry !== undefined)
      .forEach((entry) =>
        entry === null
          ? params.append(`${key}!`, "")
          : params.append(key, String(entry))
      );
  });
  params.sort();
  return params.toString();
};

export default class QueryHelper {
  static isSameQuery(
    routeQuery: FilterQuery,
    filterQuery: FilterQuery
  ): boolean {
    return canonical(routeQuery) === canonical(filterQuery);
  }
}
